import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class InvoiceaiService {
  private invoiceai_info_source = new BehaviorSubject<object>({});
  current_invoiceai_info = this.invoiceai_info_source.asObservable();
  constructor() {}

  updateInvoiceaiInfo(info) {
    this.invoiceai_info_source.next(info);
  }
}
